import AddBlockIcon from '@clearkit/icons/glyphs/AddBlock';
import AddHollowIcon from '@clearkit/icons/glyphs/AddHollow';
import { CKButton } from 'clearkit';

import { emptyNode } from '~/components/SearchBuilder/utils/constants';
import {
  insertNode,
  SearchContext,
} from '~/components/SearchBuilder/utils/searchUtils';

import { emptyGroup as emptyGroupDefault } from '../../utils/fixtures';
import AndOrDecorator from '../AndOrDecorator';
import styles from './styles';

export class UnwrappedQueryGroup extends React.Component {
  render() {
    const {
      children,
      classes,
      className,
      node,
      canAddGroup = true,
      onChange,
      search,
      emptyGroup,
    } = this.props;

    const { disabled } = this.context;
    const effectiveEmptyGroup = emptyGroup || emptyGroupDefault;

    return (
      <div className={classnames(className, classes.root)}>
        <div className={classes.queryGroupContents}>
          <AndOrDecorator node={node} search={search} onChange={onChange}>
            {children}
            <div className={classes.queryGroupActions}>
              {!disabled && (
                <>
                  <CKButton
                    className={classes.button}
                    dataTestId="add-condition-button"
                    isDisabled={disabled}
                    isSmall
                    leftIcon={<AddBlockIcon />}
                    onClick={() => {
                      const newSearch = insertNode(search, node, emptyNode);
                      onChange(newSearch);
                    }}
                    variantColor="blue"
                    variant="tertiary">
                    Add condition
                  </CKButton>
                  {canAddGroup && (
                    <CKButton
                      leftIcon={<AddHollowIcon />}
                      isDisabled={disabled}
                      className={classes.button}
                      variant="tertiary"
                      onClick={() => {
                        const newSearch = insertNode(
                          search,
                          node,
                          effectiveEmptyGroup,
                        );
                        onChange(newSearch);
                      }}>
                      Add group
                    </CKButton>
                  )}
                </>
              )}
            </div>
          </AndOrDecorator>
        </div>
      </div>
    );
  }
}

UnwrappedQueryGroup.contextType = SearchContext;

UnwrappedQueryGroup.propTypes = {
  children: PropTypes.node,
  classes: PropTypes.object,
  className: PropTypes.string,
  node: PropTypes.object,
  insertInto: PropTypes.func,
  updateNode: PropTypes.func,
  removeNode: PropTypes.func,
  canAddGroup: PropTypes.bool,
  onChange: PropTypes.func,
  search: PropTypes.object,
  emptyGroup: PropTypes.object,
};

export default withStyles(styles)(UnwrappedQueryGroup);
